import { takeLatest, call, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '../../../services/api';

export function* createPerson({ payload }) {
  try {
    const { 
      name, 
      birthday, 
      status, 
      ocupation, 
      family_count, 
      cpf, 
      nis, 
      contact, 
      address, 
      neighborhood
    } = payload;

    const person = {
      name, 
      birthday, 
      status, 
      ocupation, 
      family_count, 
      cpf, 
      nis, 
      contact, 
      address, 
      neighborhood
     };

    yield call(api.post, 'persons', person);

    toast.success('Pessoa registrada com sucesso!');
  } catch (err) {
    toast.error(err.response.data.error);
  }
}


export function* updatePerson({ payload }) {
  try {
    const { 
      name, 
      birthday, 
      status, 
      ocupation, 
      family_count,
      cpf, 
      nis, 
      contact, 
      address, 
      neighborhood,
      createdby
    } = payload;

    
    const person = {
      name, 
      birthday, 
      status, 
      ocupation, 
      family_count, 
      nis, 
      contact, 
      address, 
      neighborhood,
      createdby
    };
    
    yield call(api.put, `persons/${cpf}/update`, person);

    toast.success('Pessoa atualizada com sucesso!');
  } catch (err) {
    toast.error(err.response.data.error);
  }
}

export default all([
  takeLatest('@person/UPDATE_PERSON_REQUEST', updatePerson), 
  takeLatest('@person/CREATE_PERSON_REQUEST', createPerson), 
]);